<template>
  <div
    :class="['rounded-lg border-[1.5px] border-gray-200 bg-gray-100', compact ? 'p-2' : 'p-3']"
    data-testid="pinning-escalation-card"
  >
    <div class="flex items-center gap-2">
      <p class="m-0 text-[10px] font-bold uppercase tracking-wide text-gray-900">
        Professional edit required
      </p>
      <span class="rounded-full bg-[#00834F] px-1.5 py-0.5 text-xs font-medium text-white">
        Free
      </span>
    </div>
    <p :class="['m-0 mt-1 text-gray-900', compact ? 'text-xs' : 'text-sm']">
      Our artists will handle this after checkout.
    </p>
    <div :class="['flex gap-2', compact ? 'mt-2' : 'mt-3']">
      <button
        type="button"
        :class="[
          'rounded-lg border border-gray-300 bg-white px-3.5 py-2 text-xs font-medium text-gray-900 [font-family:inherit] hover:bg-gray-50 disabled:pointer-events-none disabled:opacity-25',
          compact ? 'flex-1' : ''
        ]"
        :disabled="isConfirming || isCancelling"
        data-testid="pinning-escalation-cancel"
        @click="$emit('cancel')"
      >
        {{ isCancelling ? "Cancelling\u2026" : "No, discard request" }}
      </button>
      <button
        type="button"
        :class="[
          'flex items-center justify-center gap-1 rounded-lg border border-[#00834F] bg-[#00834F] px-3.5 py-2 text-xs font-medium !text-white [font-family:inherit] hover:bg-[#006B40] disabled:pointer-events-none disabled:opacity-25',
          compact ? 'flex-1' : ''
        ]"
        :disabled="isConfirming || isCancelling"
        data-testid="pinning-escalation-confirm"
        @click="$emit('confirm')"
      >
        <CheckIcon class="h-4 w-4" />
        {{ isConfirming ? "Sending\u2026" : "Yes, Send to Artist" }}
      </button>
    </div>
  </div>
</template>

<script setup>
import CheckIcon from "assets/icons/check.svg?vue";

defineOptions({ name: "PinEscalationCard" });

const props = defineProps({
  isConfirming: { type: Boolean, default: false },
  isCancelling: { type: Boolean, default: false },
  compact: { type: Boolean, default: false }
});

defineEmits(["confirm", "cancel"]);
</script>
